// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DealerSearchParams = t.struct({
    account: t.String,
    city: t.String,
    division: t.String,
    name1: t.String,
}, 'DealerSearchParams');

export const getDefaultState = () => new DealerSearchParams({
    account: '',
    city: '',
    division: '',
    name1: '',
});

export default DealerSearchParams;
